/* eslint-disable no-undef */
const baseUrl = { ...WebApiBaseUrl }
if (process.env.NODE_ENV === 'development') {
  baseUrl.main = '/api'
}
export const BASEURL = baseUrl
